import * as React from 'react'

export function CompanyPanelPage() {

  // ---------------------------------------------
  // Transformations
  // ---------------------------------------------
  // Render

  return (
    <div className={'company-panel-page'}>
      Painel da empresa
    </div>
  )
}